import { polyfills, isObjectFitSupported } from './polyfills/polyfills';
import 'what-input';
import { yall } from './vendor/yall-v3.1.6';
import 'easy-toggle-state';
import { menu } from './modules/menu';
import { initSlideMenu, slideMenuElement } from './modules/slide-menu';
import { video } from './modules/video';
import { initListItemToggle } from './modules/list-item-toggle';
import { init as ageConsentAndCustomerSegmentSelectModalInit } from './modules/age-consent-and-customer-segment-select-modal';
import { initProductListingFilter } from './modules/product-listing-filter';
import { init as initCustomerSegmentPicker } from './modules/customer-segment-picker';
import { init as initNewSiteBannerModal } from './modules/new-site-banner';
import { init as newsletterInit } from './modules/newsletter';
import initPicklist from './modules/picklist/picklist';
import './modules/modal-img';
import { initReadmore } from './modules/read-more';
import { recipeRating } from './modules/recipe-rating';
import { cookiebot } from './common/cookiebot';
import { epiForms } from './modules/epi-forms';
import { accordions } from './modules/accordion';
import { timelineHeight } from './modules/timeline';

const start = () => {
  console.log('App loaded!!');
  if (!isObjectFitSupported) {
    const objectFitElements = document.querySelectorAll(
      '.js-object-fit:not(.lazy)',
    );

    if (objectFitElements) {
      objectFitPolyfill(objectFitElements);
    }
  }

  yall({
    events: {
      load: function(event) {
        const element = event.target;

        if (!element.classList.contains('lazy') && element.nodeName == 'IMG') {
          element.classList.add('lazy--loaded');

          if (
            !isObjectFitSupported &&
            element.classList.contains('js-object-fit')
          )
            objectFitPolyfill(element);
        }
      },
    },
    observeChanges: true,
  });

  const menuElement = document.getElementById('js-site-header');
  if (menuElement) {
    menu.init();
  }

  initReadmore().init();

  if (slideMenuElement()) {
    initSlideMenu();
  }
  initListItemToggle();
  initProductListingFilter();

  const videoSelector = '.js-c-video';
  video(videoSelector);

  ageConsentAndCustomerSegmentSelectModalInit();
  initNewSiteBannerModal();
  initCustomerSegmentPicker();
  initPicklist();
  newsletterInit();
  recipeRating();
  cookiebot();
  epiForms();
  accordions();
  timelineHeight();
};

export const app = () => {
  if (!polyfills) {
    start();
  } else {
    Promise.all([...polyfills])
      .then(_ => {
        try {
          start();
        } catch (error) {
          console.error('Failed to start the app', error);
        }
      })
      .catch(error => {
        console.error('Failed fetching polyfills', error);
      });
  }
};

// eslint-disable-next-line no-unused-expressions
document.readyState !== 'loading'
  ? app()
  : document.addEventListener('DOMContentLoaded', app);
